import _createForOfIteratorHelper from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
var GestureController = /*#__PURE__*/function () {
  function GestureController() {
    _classCallCheck(this, GestureController);

    this.gestureId = 0;
    this.requestedStart = new Map();
    this.disabledGestures = new Map();
    this.disabledScroll = new Set();
  }
  /**
   * Creates a gesture delegate based on the GestureConfig passed
   */


  _createClass(GestureController, [{
    key: "createGesture",
    value: function createGesture(config) {
      return new GestureDelegate(this, this.newID(), config.name, config.priority || 0, !!config.disableScroll);
    }
    /**
     * Creates a blocker that will block any other gesture events from firing. Set in the ion-gesture component.
     */

  }, {
    key: "createBlocker",
    value: function createBlocker() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new BlockerDelegate(this, this.newID(), opts.disable, !!opts.disableScroll);
    }
  }, {
    key: "start",
    value: function start(gestureName, id, priority) {
      if (!this.canStart(gestureName)) {
        this.requestedStart.delete(id);
        return false;
      }

      this.requestedStart.set(id, priority);
      return true;
    }
  }, {
    key: "capture",
    value: function capture(gestureName, id, priority) {
      if (!this.start(gestureName, id, priority)) {
        return false;
      }

      var requestedStart = this.requestedStart;
      var maxPriority = -10000;
      requestedStart.forEach(function (value) {
        maxPriority = Math.max(maxPriority, value);
      });

      if (maxPriority === priority) {
        this.capturedId = id;
        requestedStart.clear();
        var event = new CustomEvent('ionGestureCaptured', {
          detail: {
            gestureName: gestureName
          }
        });
        document.dispatchEvent(event);
        return true;
      }

      requestedStart.delete(id);
      return false;
    }
  }, {
    key: "release",
    value: function release(id) {
      this.requestedStart.delete(id);

      if (this.capturedId === id) {
        this.capturedId = undefined;
      }
    }
  }, {
    key: "disableGesture",
    value: function disableGesture(gestureName, id) {
      var set = this.disabledGestures.get(gestureName);

      if (set === undefined) {
        set = new Set();
        this.disabledGestures.set(gestureName, set);
      }

      set.add(id);
    }
  }, {
    key: "enableGesture",
    value: function enableGesture(gestureName, id) {
      var set = this.disabledGestures.get(gestureName);

      if (set !== undefined) {
        set.delete(id);
      }
    }
  }, {
    key: "disableScroll",
    value: function disableScroll(id) {
      this.disabledScroll.add(id);

      if (this.disabledScroll.size === 1) {
        document.body.classList.add(BACKDROP_NO_SCROLL);
      }
    }
  }, {
    key: "enableScroll",
    value: function enableScroll(id) {
      this.disabledScroll.delete(id);

      if (this.disabledScroll.size === 0) {
        document.body.classList.remove(BACKDROP_NO_SCROLL);
      }
    }
  }, {
    key: "canStart",
    value: function canStart(gestureName) {
      if (this.capturedId !== undefined) {
        // a gesture already captured
        return false;
      }

      if (this.isDisabled(gestureName)) {
        return false;
      }

      return true;
    }
  }, {
    key: "isCaptured",
    value: function isCaptured() {
      return this.capturedId !== undefined;
    }
  }, {
    key: "isScrollDisabled",
    value: function isScrollDisabled() {
      return this.disabledScroll.size > 0;
    }
  }, {
    key: "isDisabled",
    value: function isDisabled(gestureName) {
      var disabled = this.disabledGestures.get(gestureName);

      if (disabled && disabled.size > 0) {
        return true;
      }

      return false;
    }
  }, {
    key: "newID",
    value: function newID() {
      this.gestureId++;
      return this.gestureId;
    }
  }]);

  return GestureController;
}();

var GestureDelegate = /*#__PURE__*/function () {
  function GestureDelegate(ctrl, id, name, priority, disableScroll) {
    _classCallCheck(this, GestureDelegate);

    this.id = id;
    this.name = name;
    this.disableScroll = disableScroll;
    this.priority = priority * 1000000 + id;
    this.ctrl = ctrl;
  }

  _createClass(GestureDelegate, [{
    key: "canStart",
    value: function canStart() {
      if (!this.ctrl) {
        return false;
      }

      return this.ctrl.canStart(this.name);
    }
  }, {
    key: "start",
    value: function start() {
      if (!this.ctrl) {
        return false;
      }

      return this.ctrl.start(this.name, this.id, this.priority);
    }
  }, {
    key: "capture",
    value: function capture() {
      if (!this.ctrl) {
        return false;
      }

      var captured = this.ctrl.capture(this.name, this.id, this.priority);

      if (captured && this.disableScroll) {
        this.ctrl.disableScroll(this.id);
      }

      return captured;
    }
  }, {
    key: "release",
    value: function release() {
      if (this.ctrl) {
        this.ctrl.release(this.id);

        if (this.disableScroll) {
          this.ctrl.enableScroll(this.id);
        }
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.release();
      this.ctrl = undefined;
    }
  }]);

  return GestureDelegate;
}();

var BlockerDelegate = /*#__PURE__*/function () {
  function BlockerDelegate(ctrl, id, disable, disableScroll) {
    _classCallCheck(this, BlockerDelegate);

    this.id = id;
    this.disable = disable;
    this.disableScroll = disableScroll;
    this.ctrl = ctrl;
  }

  _createClass(BlockerDelegate, [{
    key: "block",
    value: function block() {
      if (!this.ctrl) {
        return;
      }

      if (this.disable) {
        var _iterator = _createForOfIteratorHelper(this.disable),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var gesture = _step.value;
            this.ctrl.disableGesture(gesture, this.id);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      if (this.disableScroll) {
        this.ctrl.disableScroll(this.id);
      }
    }
  }, {
    key: "unblock",
    value: function unblock() {
      if (!this.ctrl) {
        return;
      }

      if (this.disable) {
        var _iterator2 = _createForOfIteratorHelper(this.disable),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var gesture = _step2.value;
            this.ctrl.enableGesture(gesture, this.id);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      if (this.disableScroll) {
        this.ctrl.enableScroll(this.id);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.unblock();
      this.ctrl = undefined;
    }
  }]);

  return BlockerDelegate;
}();

var BACKDROP_NO_SCROLL = 'backdrop-no-scroll';
var GESTURE_CONTROLLER = new GestureController();
export { GESTURE_CONTROLLER as G };